export default __webpack_public_path__ + "login_footer_1.3eb114.svg";